const LANTERN = "https://static.prod-images.emergentagent.com/jobs/f12c7e32-58f0-4ea3-8168-eca87b403141/images/6fe68f5c939077eaaa1059f913b7cddae6d0e94ad983f3f56c7bdaeeedfdcb11.png";

export default function OurStory() {
  return (
    <section id="story" data-testid="our-story" className="py-24 md:py-32 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        <div className="md:col-span-5 relative">
          <div className="aspect-[4/5] rounded-3xl overflow-hidden bg-[#F4EFE6] border border-[#EADAB9]">
            <img
              src={LANTERN}
              alt="A warm lantern glowing in the evening"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#FDFBF7] border border-[#EADAB9] rounded-2xl px-6 py-4 shadow-sm">
            <p className="font-accent text-3xl text-[#C25934]">— since 2026</p>
          </div>
        </div>

        <div className="md:col-span-7">
          <p className="label-eyebrow mb-6">Our Story</p>
          <h2 className="font-headline font-light text-4xl md:text-5xl text-[#1F1A17] leading-tight">
            Built on the simple idea that <span className="italic text-[#C25934]">everyone deserves an evening</span> with dignity.
          </h2>
          <div className="mt-8 space-y-5 text-lg text-[#5A524A] leading-relaxed">
            <p>
              We saw a need for services in the evening — the quiet gap between when daytime
              programs close their doors and overnight shelters open theirs. In those hours,
              our homeless neighbors are too often left without somewhere safe to land.
              Hearthside exists to close that gap, so people can have their needs met at
              every hour of the day.
            </p>
            <p>
              We're currently working on opening a dedicated space — a steady, evening refuge
              where members of the homeless community can find safety, warmth, and real
              support. A place to eat a freshly cooked meal, pick up hygiene supplies, sit in
              good company, and be treated with the dignity every person deserves.
            </p>
          </div>
          <p className="mt-10 font-accent text-3xl text-[#5C6B51]">
            with love, the Hearthside team
          </p>
        </div>
      </div>
    </section>
  );
}
